module.exports = __webpack_public_path__ + "img/ans.1efddde5.png";